import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { LoadIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { ShipmentLoadEndpoint } from '../../constants/shipment-load-endpoint';
import { Observable } from 'rxjs';
import { ShipmentLoadOverview } from '../../models/shipment-load.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadMainInfoService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData(loadIdView: LoadIdView): Observable<ShipmentLoadOverview> {
    return this.http
      .withLoading()
      .get<ShipmentLoadOverview>(
        `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${
          ShipmentLoadEndpoint.Summary
        }?${getQueryStringFromObject(loadIdView)}`,
      );
  }
}
